import React from 'react';

import { RadioCheckedIcon } from '../../assets';

/**
 * One of the two "ترتيب ظهور الأسئلة" cards — nodes 16370:191865 and 191871.
 *
 * Picked, it is a blue/50 card with a 2px brand ring and the file's own radio;
 * otherwise white, a 1px gray/200 ring and an empty disc. The picked card gives
 * back the extra pixel of ring in its padding, so the text does not shift when
 * the choice moves.
 *
 * The text comes first and the radio last, as the frame draws it: the radio at
 * the far end of the card.
 */
const ChoiceCard = ({ name, value, checked, onChange, title, lead }) => (
    <label
        className={
            'tw-relative tw-flex tw-min-w-0 tw-flex-1 tw-cursor-pointer tw-items-center tw-gap-[16px] tw-rounded-[16px] ' +
            'tw-border-solid tw-transition-colors ' +
            (checked
                ? 'tw-border-2 tw-border-v2-brand tw-bg-v2-brand-tint tw-p-[19px]'
                : 'tw-border tw-border-v2-neutral-200 tw-bg-white tw-p-[20px] hover:tw-bg-v2-neutral-50')
        }
    >
        <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-[4px] tw-text-start">
            <span className={`tw-text-[15px] tw-font-bold tw-leading-[1.4] ${checked ? 'tw-text-v2-neutral-900' : 'tw-text-v2-student-label'}`}>
                {title}
            </span>
            <span className={`tw-text-[12px] tw-leading-[1.5] ${checked ? 'tw-text-v2-student-nav' : 'tw-text-v2-neutral-400'}`}>
                {lead}
            </span>
        </span>

        <input type="radio" name={name} value={value} checked={checked} onChange={onChange} className="tw-peer tw-sr-only" />
        <span aria-hidden className="tw-flex tw-size-[20px] tw-shrink-0 tw-rounded-full peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-v2-brand peer-focus-visible:tw-ring-offset-2">
            {checked
                ? <RadioCheckedIcon width={20} height={20} className="tw-block tw-text-v2-brand" />
                : <span className="tw-size-[20px] tw-rounded-full tw-border-2 tw-border-solid tw-border-v2-student-box tw-bg-white" />}
        </span>
    </label>
);

export default ChoiceCard;
